import './thompson2/style';
import FormStructure from './thompson2/form_structure';

export default FormStructure;